module.exports = __webpack_public_path__ + "img/characteripad.4cf57ce9.svg";